import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
} from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';

const NotFoundPage = () => {
  const theme = useTheme();
  
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          textAlign: 'center',
          py: 8,
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          fontWeight={800}
          color="primary"
          sx={{ 
            fontSize: { xs: '6rem', md: '10rem' },
            mb: 2,
            opacity: 0.8,
          }}
        >
          404
        </Typography>
        
        <Typography
          variant="h4"
          component="h2"
          fontWeight={700}
          gutterBottom
        >
          Page Not Found
        </Typography>
        
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ 
            maxWidth: 450,
            mb: 4,
          }}
        >
          We couldn't find the page you're looking for. The page may have been moved, 
          deleted, or is temporarily unavailable.
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            component={RouterLink}
            to="/"
          >
            Back to Home
          </Button>
          
          <Button
            variant="outlined"
            color="primary"
            size="large"
            component={RouterLink}
            to="/listings"
          >
            Browse Properties
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFoundPage;